import React from 'react'
import data from "../data";
const TeamTwo = (props) => {
    const itemSlice = data.slice(0 , props.item)
    return (
        <div className="row justify-content-center">
            {itemSlice.map((value , i ) => (
                <div className={`${props.column}`} key={i}>
                    <div className={`team-static ${props.teamStyle}`}>
                        <div className="thumbnail">
                            <img src={`/assets/images/team/${value.images}.png`} alt="Blog Images"/>
                        </div>
                        <div className="inner">
                            <div className="content">
                                <h4 className="title">{value.title}</h4>
                                <p className="designation">{value.designation}</p>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
export default TeamTwo
